"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToothSurfaceMaskValue_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ToothSurfaceMaskValue_Factory = /** @class */ (function () {
    function ToothSurfaceMaskValue_Factory() {
    }
    ToothSurfaceMaskValue_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CombinationString: model.CombinationString,
            ToothSurfaceMaskValue1: model.ToothSurfaceMaskValue1,
        };
        return result;
    };
    ToothSurfaceMaskValue_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CombinationString: model.CombinationString,
            ToothSurfaceMaskValue1: model.ToothSurfaceMaskValue1,
        };
        return result;
    };
    return ToothSurfaceMaskValue_Factory;
}());
exports.ToothSurfaceMaskValue_Factory = ToothSurfaceMaskValue_Factory;
